<template>
  <div class="grouped-button">
    <Button class="icon icon-left sm full-size" :class="$i18n.locale.includes(locale) ? 'secondary' : 'transparent'" :label="$t(`other.languages.${locale}`)" icon="bi bi-flag" @click="setLocale(locale)" v-for="locale in availableLocales" :key="locale" />
  </div>
</template>

<script setup lang="ts">
import { setLocale } from "@/i18n/index.js";

const availableLocales = ["fr", "en"];
</script>
